export const SHOW_BINBAG_ERROR = 'SHOW_BINBAG_ERROR'
export const DISMISS_BINBAG_ERROR = 'DISMISS_BINBAG_ERROR'
export const GET_BINBAG_FAILED = 'GET_BINBAG_FAILED'
export const GET_BINBAG_SUCCEED = 'GET_BINBAG_SUCCEED'
export const GET_BINBAG_PROCESSING = 'GET_BINBAG_PROCESSING'
export const REQUEST_BINBAGS_SUCCEED = 'REQUEST_BINBAGS_SUCCEED'
export const GET_BINBAG_ORDER_AMOUNT_SUCCEED = 'GET_BINBAG_ORDER_AMOUNT_SUCCEED'
